import React from "react";

const Started = props => (
  <svg viewBox="0 0 26 26" {...props}>
    <g
      transform="translate(1 1)"
      stroke="currentColor"
      fill="none"
      fillRule="evenodd"
    >
      <ellipse strokeWidth={1.469} cx={12} cy={11.93} rx={12} ry={11.879} />
      <path
        d="M4.303 17.147c-.402-.609.713-3.355 1.158-3.787L16.13 6.473a2.47 2.47 0 011.842-.342 2.45 2.45 0 011.547 1.047c.355.539.48 1.195.346 1.824a2.424 2.424 0 01-1.058 1.531L8.138 17.421c-.375.097-3.434.334-3.835-.274zM14.407 7.583l2.613 3.983"
        strokeWidth={1.224}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default Started;
